import { createAction, props } from '@ngrx/store';
import { Tip, TipDetail } from '@core/models';

export const TIP_FIND = createAction('[Tip] Find');
export const TIP_FIND_SUCCESS = createAction('[Tip] Find Success', props<{ tip: Tip }>());
export const TIP_FIND_ALL_SUCCESS = createAction('[Tip] Find All Success', props<{ tipList: Tip[] }>());
export const TIP_FAILED = createAction('[Tip] Failed', props<{ error: string }>());
export const TIP_UPDATE_LOADING = createAction('[Tip] Update Loading', props<{ loading: boolean }>());
export const TIP_UPDATE_ID = createAction('[Tip] Update Id', props<{ tipId: string }>());
export const TIP_UPDATE = createAction('[Tip] Update', props<{ tip: Tip }>());

export const TIP_DETAIL_FIND_SUCCESS = createAction('[Tip] Update Detail Find Success', props<{ tipDetail: TipDetail | null}>());
